import { useMediaQuery, useTheme } from '@mui/material';
import { useAuthState } from 'state/useAuthState';
import { useSearchDrawerState } from 'state/useSearchDrawerState';

/**
 * Advanced search is only available to pro members, and only while the drawer
 * is actually open: on desktop that's the persistent drawer's `open` state, on
 * mobile it's the bottom sheet's open state (passed in via `isSheetOpen`).
 */
export const useShowAdvancedSearch = (isSheetOpen: boolean): boolean => {
  const { showMembershipProFeatures } = useAuthState();
  const theme = useTheme();
  const isLargeMediaQuery = useMediaQuery(theme.breakpoints.up('tablet'));
  const { open: isSearchDrawerOpen } = useSearchDrawerState();

  return (
    showMembershipProFeatures &&
    (isLargeMediaQuery ? isSearchDrawerOpen : isSheetOpen)
  );
};
